import WarrantyPricingModel from '@models/api/products/warranty-pricing-model'

class PackageSkuItemModel {
  constructor(values = {}) {
    this.sku = values?.sku || ''
    this.quantity = values?.quantity || ''
    this.price = values?.price || ''
    this.warranty_pricing = new WarrantyPricingModel(values?.warranty_pricing || {})
  }
}

export default PackageSkuItemModel
